import * as Vue from 'vue'
const allVue = Vue
const gh = allVue.h
import KendoDropDownListMixin from './KendoDropDownListMixin'

export default {
    name: 'kendo-dropdownlist',
    mixins: [ KendoDropDownListMixin ],
    setup() {
        const v3 = !!gh
        return {
            v3
        }
    },
    render(createElement) {
        const h = gh || createElement
        return h('input', [
            this.$slots['kendo-datasource']
        ])
    }
}


// WEBPACK FOOTER //
// ./packages/kendo-dropdowns-vue-wrapper/src/KendoDropDownList/index.js